import ConvenienceStore from '../../../../images/nearbyPlaces/convenience_store.png';
import SuperMarket from '../../../../images/nearbyPlaces/super_market.png';
import VendingMachine from '../../../../images/nearbyPlaces/vending_machine.png';

export const Icons = {
  convenienceStore: ConvenienceStore,
  superMarket: SuperMarket,
  vendingMachine: VendingMachine,
};

export const KINDS = {
  CONVENIENCE_STORE_KIND: 'convenience_store',
  SUPER_MARKET_KIND: 'super_market',
  VENDING_MACHINE_KIND: 'vending_machine',
};
